import { useQuery } from '@apollo/client/react';

import { GetSessionDataDocument } from './__generated__/GetSessionData';

export const useSessionQuery = () => {
  const { data, loading, error } = useQuery(GetSessionDataDocument);
  const human = data?.session?.human;
  return {
    email: human?.email,
    fullName: human?.full_name,
    impersonated: Boolean(human?.impersonated),
    data,
    loading,
    error,
  };
};
